import dashboardImgUrl from '../../../images/portfolio/web-images/tailwindcss/dashboard.jpg';
import primePropertiesImgUrl from '../../../images/portfolio/web-images/tailwindcss/prime-properties.jpg';
import asaWebsiteImgUrl from '../../../images/portfolio/web-images/react/amr-saad-abdallah-website.jpg';
import emarketingWebsiteImgUrl from '../../../images/portfolio/web-images/react/e-marketing.jpg';

const tailwindcssTemplateList = [
	{
		imgUrl: asaWebsiteImgUrl,
		title: 'My Website',
		githubUrl: 'https://github.com/amrsaadabdallah/my-website',
		infoUrl: 'https://github.com/amrsaadabdallah/amrsaadabdallah.github.io',
		liveUrl: 'https://amrsaadabdallah.github.io',
		type: 'small',
	},
	{
		imgUrl: emarketingWebsiteImgUrl,
		title: 'E-Marketing',
		githubUrl: 'https://github.com/amrsaadabdallah/my-e-marketing-react-app',
		infoUrl: 'https://github.com/amrsaadabdallah/e-marketing-react-app',
		liveUrl: 'https://amrsaadabdallah.github.io/e-marketing-react-app',
		type: 'large',
	},
	{
		imgUrl: dashboardImgUrl,
		title: 'Dashboard',
		githubUrl: 'https://github.com/amrsaadabdallah/my-dashboard',
		infoUrl: 'https://github.com/amrsaadabdallah/dashboard',
		liveUrl: 'https://amrsaadabdallah.github.io/dashboard',
		type: 'large',
	},
	{
		imgUrl: primePropertiesImgUrl,
		title: 'Prime Properties',
		githubUrl: 'https://github.com/amrsaadabdallah/my-prime-properties',
		infoUrl: 'https://github.com/amrsaadabdallah/prime-properties',
		liveUrl: 'https://amrsaadabdallah.github.io/prime-properties',
		type: 'large',
	},
];

export default tailwindcssTemplateList;
